import { render } from "./성장_장건강_대사증후군클리닉.vue?vue&type=template&id=2a1f11ab"
import script from "./성장_장건강_대사증후군클리닉.vue?vue&type=script&lang=js"
export * from "./성장_장건강_대사증후군클리닉.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__